"use client";

import useInteractionTracker from "@blueshift-ui/telemetry/dist/hooks/use-interaction-tracker";

export default useInteractionTracker;


